import React from 'react';
import Image from 'next/image';
import { Button, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import Images from '@/const/images';
import { TourStepHeader } from '@/components/modals/guided-tour/TourStepHeader';
import { TourStepTracker } from '@/components/modals/guided-tour/TourStepTracker';
import { GuidedTourStepProps } from '@/interfaces';

export const StepWhatHappensNext: React.FC<GuidedTourStepProps> = ({
	onClose,
	onNext,
	currentStep,
	totalSteps,
}) => {
	return (
		<div className="flex flex-col h-full">
			<TourStepHeader onClose={onClose} className="pt-6 md:pt-10">
				<Image src={Images.whatHappensGroup} alt="" width={556} height={320} />
			</TourStepHeader>

			<div className="flex flex-col flex-1 min-h-0 px-5 md:px-10 pt-6 pb-8">
				<Typography
					type="regular-12"
					className="!text-gray-35 uppercase tracking-[0.08em]"
				>
					Step 1 of 3 — What&apos;s expected of you
				</Typography>

				<Typography type="semibold-24" className="mt-2">
					What happens next
				</Typography>

				<Typography type="regular-18" className="mt-8">
					To move your case forward, you&apos;ll need to{' '}
					<span className="font-semibold text-black">
						provide documentation of how you were harmed.
					</span>{' '}
					We&apos;ll also send documents for you to review and sign.
				</Typography>

				<div className="flex items-center gap-3 rounded-xl bg-[#EBDFFA4D] p-3 mt-3">
					<Icon
						src={Icons.infoCircle}
						className="!size-6 !text-primary shrink-0"
					/>
					<Typography type="regular-16" className="!text-black text-left">
						<span className="font-semibold">Stay responsive.</span> Quick action
						keeps you eligible for any eventual settlement.
					</Typography>
				</div>

				<div className="flex items-center justify-between mt-auto pt-8">
					<TourStepTracker currentStep={currentStep} totalSteps={totalSteps} />
					<Button
						decoration="primary"
						size="fit"
						className="!w-[156px] !h-[48px]"
						onClick={onNext}
					>
						Next
					</Button>
				</div>
			</div>
		</div>
	);
};
